// Minimal runtime breadcrumbing to console + Sentry (if present)
export function markBoot(stage: string, extra?: Record<string, unknown>) {
  // always console
  // eslint-disable-next-line no-console
  console.log('[BOOT]', stage, extra ?? {});
  // try Sentry if loaded
  try {
    const Sentry = (window as any).Sentry || undefined;
    if (Sentry?.captureMessage) {
      Sentry.captureMessage(`BOOT_${stage}`, { level: 'info', extra });
    }
  } catch {}
  (window as any).__BOOT__ = { stage, ts: Date.now(), extra };
}
